import React, { useState, useEffect } from 'react';
import { Box, Grid, Card, CardContent, Typography, CardHeader, List, ListItem, ListItemText, ListItemIcon, Button, CardActions } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DashboardNavbar from '../../Components/DashboardNavbar/DashboardNavbar';
import { Stack } from '@mui/material';
import { useNavigate, Link } from "react-router-dom";
import CookieLoad from '../../util/CookieLoad';
import moment from 'moment';

function StudentHome(props) {
    const [group, setGroup] = useState({});
    const [teamData, setTeamData] = useState([]);
    const [projectSponsor, setProjectSponsor] = useState('');
    const [teamNumber, setTeamNumber] = useState('');
    const [projectData, setProjects] = useState([]);
    const [assignments, setAssignments] = useState([]);

    const navigate = useNavigate();

    const [token, setToken] = useState({});

    function teamDataToReact(dataArray) {
        setGroup(dataArray);
        setTeamNumber(dataArray.number);
        setProjectSponsor((!dataArray.project?.sponsor || dataArray.project.sponsor === '') ? 'Unknown' : dataArray.project.sponsor);

        const members = dataArray.members?.length > 0 && dataArray.members.map((data, i) => {
            const name = data.first_name + ' ' + data.last_name;
            return <ListItem key={dataArray.name + '-' + i}>
                <ListItemIcon style={{ maxWidth: '30px', minWidth: '30px' }}>
                    <PersonIcon />
                </ListItemIcon>
                <ListItemText>{name}</ListItemText>
            </ListItem>
        });

        setTeamData(members ? members : []);
    }

    function projectDataToReact(dataArray) {
        const projects = dataArray.map((data, i) => {
            return (
                <ListItem style={{ paddingTop: '0px', paddingBottom: '0px' }} key={data.name + '-' + i}>
                    <ListItemText>{data.name}</ListItemText>
                </ListItem>
            )
        });
        setProjects(projects);
    }

    // api call to get the users group data
    function loadTeamData(token) {
        if(!token){
            return;
        }
        fetch(`${process.env.REACT_APP_API_HOST}/api/groups/findGroup`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token.access_token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
        })
            .then(res => res.json())
            .then(j => teamDataToReact(j))
            .catch(error => console.error(error))
    }

    // api call to get the project data
    function loadProjectData(token) {
        fetch(`${process.env.REACT_APP_API_HOST}/api/projects/getAllForClass`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token.access_token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
        })
            .then(res => res.json())
            .then(j => projectDataToReact(j))
            .catch(error => console.error(error))
    }

    function loadAssignments(token) {
        fetch(`${process.env.REACT_APP_API_HOST}/api/forms/assignments`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token.access_token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
        })
            .then(res => res.json())
            .then(j => {
                if (j.length > 0) {
                    let openAssignments = j.filter((assignment) => moment(assignment.start).isBefore(moment()));
                    setAssignments([...openAssignments]);
                }
            }).catch(error => console.error(error))
    }

    useEffect(() => {
        const getTokens = async () => {
            const tokens = await CookieLoad();
            if (!tokens) {
                navigate("/");
                console.log("Cannot login user");
            }
            setToken(tokens);
            loadTeamData(tokens);
            loadProjectData(tokens);
            loadAssignments(tokens);
        }
        getTokens();
    }, []);


    return (
        <Box>
            <DashboardNavbar userType='student' />
            <Stack spacing={2} sx={{ minWidth: 80, p: 2, mx: 5, maxWidth: 1400 }}>
                <Typography variant='h4'>Home</Typography>
                <Grid container spacing={2} >
                    {teamData.length > 0 &&
                    <Grid item xs={12} md={5}>
                        <Card style={{ padding: 10, paddingLeft: 15, minHeight: 100, background: '#C4C4C4', maxWidth: 500}}>
                            <CardHeader
                                title={
                                    <Typography variant='h5' style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
                                        Team {teamNumber}: {group.project?.name}
                                    </Typography>
                                }
                                subheader={
                                    <Typography variant='h6'>
                                        Sponsor: {projectSponsor}
                                    </Typography>
                                }
                                style={{ paddingBottom: '0px' }} />
                            <CardContent style={{ paddingTop: '0px' }}>
                                <List style={{ padding: '0px' }}>
                                    {teamData}
                                </List>
                            </CardContent>
                            <CardActions style={{ justifyContent: 'center' }}>
                                <Button variant='contained' onClick={() => navigate("/team")}>View</Button>
                            </CardActions>
                        </Card>
                    </Grid>}
                    {teamData.length <= 0 &&
                    <Grid item xs={12} md={5}>
                        <Card style={{ padding: 10, paddingLeft: 15, minHeight: 100, background: '#C4C4C4' }}>
                            <CardHeader
                                title={
                                    <Typography variant='h5' style={{ fontWeight: 'bold', textDecoration: 'underline', maxWidth: 800 }}>
                                        Projects:
                                    </Typography>
                                }
                                style={{ paddingBottom: '0px' }} />
                            <CardContent >
                                <List style={{ padding: '0px' }}>
                                    {projectData}
                                </List>
                            </CardContent>
                            <CardActions style={{ justifyContent: 'center' }}>
                                <Button variant='contained' onClick={() => navigate("/rankprojects", {state: {token: token}})}>Rank</Button>
                            </CardActions>
                        </Card>
                    </Grid>}
                    <Grid item xs={12} sm={12} md={7}>
                        <Card style={{ padding: 10, paddingLeft: 15, minHeight: 100, background: '#C4C4C4', maxWidth: 800 }}>
                            <CardHeader
                                title={
                                    <Typography variant='h5' style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
                                        To Do:
                                    </Typography>
                                }
                                style={{ paddingBottom: '0px' }} />
                            <CardContent >
                                {assignments.length > 0 ?                                   
                                    <Grid container spacing={1}>
                                        <Grid item xs={1} sx={{fontSize: "18px", fontWeight: "bold"}}></Grid>
                                        <Grid item xs={3} sx={{fontSize: "18px", fontWeight: "bold"}}>Name</Grid>
                                        <Grid item xs={4} sx={{fontSize: "18px", fontWeight: "bold"}}>Start</Grid>
                                        <Grid item xs={4} sx={{fontSize: "18px", fontWeight: "bold"}}>End</Grid>
                                        {assignments.map((assignment) => (
                                        <Grid container item key={assignment.assignment_id}>
                                            <Grid item xs={1}>
                                                {assignment.is_completed ? <CheckBoxIcon /> :<CheckBoxOutlineBlankIcon /> }
                                            </Grid>
                                            <Grid item xs={3}>
                                                {
                                                    moment(assignment.end).isBefore(moment()) ?
                                                    <Typography style={{color: 'black'}}>{assignment.name + " (Closed)"}</Typography>
                                                    : assignment.template_id === -1 ?
                                                    <Link to="/assignment1" state={{token: token, assignment: assignment}} style={{color: 'black'}}>{assignment.name}</Link>
                                                    : assignment.template_id === -3 ?
                                                    <Link to="/projectsubmission" state={{token: token, assignment: assignment}} style={{color: 'black'}}>{assignment.name}</Link>
                                                    :
                                                    <Link to="/assignment" state={{token: token, assignment: assignment}} style={{color: 'black'}}>{assignment.name}</Link>
                                                }
                                            </Grid>
                                            <Grid item xs={4}>
                                                {moment(assignment.start).format('MMMM Do, h:mm a')}
                                            </Grid>
                                            <Grid item xs={4}>
                                                {moment(assignment.end).format('MMMM Do, h:mm a')}
                                            </Grid>
                                        </Grid>
                                        ))}
                                    </Grid>
                                    :
                                    <Typography>All tasks are done</Typography>
                                }
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Stack>
        </Box>
    );
}

export default StudentHome;